"use strict";

(function (Drupal) {
  Drupal.behaviors.dartInstagramExt = {
    attach: function attach(context, settings) {
      var layout = context.querySelectorAll('.layout--onecol');
      if (!layout.length) {
        return;
      }
      layout.forEach(function (item) {
        if (item.contains(item.querySelector('.instagram-post--external'))) {
          item.classList.add('instagram-is-single');
        }
      });
    }
  };
})(Drupal);